var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-hcaptcha',{ref:"captcha",attrs:{"sitekey":_vm.key_captcha,"theme":_vm.theme},on:{"verify":_vm.handleVerify,"expired":_vm.handleExpired,"error":_vm.handleError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }